import authInstance from "../Interceptor";

export const AddWholesalerProductEffect = (WholesalerProductData, config) => {
  return authInstance.post(
    "/wholesaler_products/add",
    WholesalerProductData,
    config
  );
};

export const EditWholesalerProductEffect = (
  WholesalerProductId,
  updatedData
) => {
  return authInstance.put(
    `/wholesaler_products/update/${WholesalerProductId}`,
    updatedData
  );
};

export const DeleteWholesalerProductEffect = (WholesalerProductId) => {
  return authInstance.delete(`/wholesaler_products/delete/${WholesalerProductId}`);
};

export const ViewWholesalerProductEffect = (WholesalerProductId) => {
  return authInstance.get(
    `/wholesaler_products/get?wholesaler_product_id=${WholesalerProductId}`
  );
};

export const ViewAllWholesalerProductsEffect = (pageNo) => {
  return authInstance.get(
    `/wholesaler_products/list?pagination_required=true&pagesize=10&pageNo=${pageNo}`
  );
};

export const ViewAllWholesalerProductsByWholesalerIdEffect = (
  wholesalerProductId,
  pageNo,
  search_key
) => {
  return authInstance.get(
    `/wholesaler_products/wholesalerProductsByWholesalerId?wholesaler_id=${wholesalerProductId}&pageNo=${pageNo}&search_key=${search_key}&pagesize=10&pagination_required=true`
  );
};

export const ViewAllSearchWholesalerProductsByWholesalerIdEffect = (
  WholesalerProductId
) => {
  return authInstance.get(
    `/wholesaler_products/wholesalerProductsByWholesalerId?wholesaler_id=${WholesalerProductId}`
  );
};

export const ViewAllSearchWholesalerProductsEffect = () => {
  return authInstance.get(`/wholesaler_products/list`);
};
